import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'gas-spinner',
  templateUrl: './gas-spinner.component.html',
  styleUrls: ['./gas-spinner.component.scss', './gas-spinner-animate.component.scss'],
  host: {
    '[class._ultra-small]': `size === 'ultra-small'`,
    '[class._x-small]': `size === 'x-small'`,
    '[class._small]': `size === 'small'`,
    '[class._medium]': `size === 'medium'`,
    '[class._large]': `size === 'large'`,
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSpinnerComponent {

  @Input()
  public size: 'ultra-small' | 'x-small' | 'small' | 'medium' | 'large' = 'large';

  @Input()
  public variant: 'brand' | 'inverse' | 'white' = 'brand';

  public sizeGrid = {
    large: {
      size: '12px',
    },
    medium: {
      size: '8px',
    },
    small: {
      size: '6px',
    },
    'x-small': {
      size: '4px',
    },
    'ultra-small': {
      size: '3px',
    },
  };

  public getBackgroundClass(): string {
    switch(this.variant) {
      case 'brand':
        return 'base-bg-priority-medium';

      case 'inverse':
        return 'base-bg-blacked';

      case 'white':
        return 'base-bg-page';
    }
  }
}
